import { createUserWithEmailAndPassword } from 'firebase/auth'
import { useRef, useState } from 'react'
import { ClipLoader } from 'react-spinners'
import { toast, ToastContainer } from 'react-toastify'
import { css } from "@emotion/react";
import 'react-toastify/dist/ReactToastify.css'
import { auth, db } from '../../firebase'
import { Link } from 'react-router-dom';
import { doc, serverTimestamp, setDoc } from 'firebase/firestore';
import images from '../../assets';
import ReCAPTCHA from 'react-google-recaptcha';

const Signup = () => {
  const [loading, setLoading] = useState(false)
  const [captchaVerified, setCaptchaVerified] = useState(false)
  const recaptcha = useRef()
  const name = useRef(null)
  const email = useRef(null)
  const password = useRef(null)
  const form = useRef()

  const override = css`
  display: block;
  margin: 0 auto;
  border: 3px solid black;
`;

  const handleSignUP = async (e)=>{
      e.preventDefault()
       if(e.target.checkValidity()){
         if(!captchaVerified) return toast.error("Please verify you're not robot.")
         setLoading(true)
         createUserWithEmailAndPassword(auth, email.current.value, password.current.value)
          .then(async (userCredential) => {
            const user = userCredential.user;
            if(!user) return

            await setDoc(doc(db, "admins", user.uid), {
                email: email.current.value,
                name: name.current.value,
                timestamp: serverTimestamp()
            });
            setLoading(false)
            setCaptchaVerified(false)
            toast.success('Account created successfully.')
            form.current.reset()
            recaptcha.current.reset()
          })
          .catch((error) => {
            const errorMessage = error.message;
            toast.error(errorMessage)
            setLoading(false)
          });
        }else{
        const formData = new FormData(e.target)
        const validationMessages = Array.from(formData.keys())
          .reduce((acc, key) => {
            acc[key] = form.current.elements[key].validationMessage
            return acc
          }, {})
          toast.error(
            validationMessages.name !== '' ? 
            'Name: '+validationMessages.name :
            validationMessages.email !== '' ?
            validationMessages.email :
            validationMessages.password !== '' ?
            validationMessages.password : null
          )
      }
  }

  return (
    <div className="flex flex-col justify-center md:flex-row md:justify-around items-center bg-gray-50 h-[100vh]">
      <div className="flex">
        <img src={images.logomachine} className='mb-8 mr-4 md:mb-0 md:mr-0' alt="logo" />
      </div>
    <div className="bg-gray-100 w-full sm:w-[380px] pt-3 pb-3 sm:rounded-md shadow-lg shadow-slate-300s border border-gray-300">
        <h1 className="text-center text-gray-900 font-bold p-3 text-2xl mt-2">Create admin account</h1>
        <form ref={form} noValidate autoComplete='off' className="flex flex-col px-4 py-3" onSubmit={handleSignUP}>
            <input ref={name} required name='name' type="text" minLength='3' className="mt-1 mb-3 p-3 outline-none rounded-md border border-gray-300 focus:border-red-600" placeholder="Full Name" />
            <input ref={email} required name='email' type="email" className="mt-1 mb-3 p-3 outline-none rounded-md border border-gray-300 focus:border-red-600" placeholder="Email / Username"/>
            <input ref={password} name='password' type="password" minLength='8' maxLength='30' className="my-3 p-3 outline-none rounded-md border border-gray-300 focus:border-red-600" placeholder="Password" />
           
            <ReCAPTCHA
              // sitekey="6LeIxAcTAAAAAJcZVRqyHh71UMIEGNQ_MXjiZKhI"
              ref={recaptcha}
              sitekey="6LfzuCohAAAAAExAv_-JWqPv1dusykVr5wZHjB-M"
              onChange={()=> setCaptchaVerified(!captchaVerified)}
            />

            <button type='submit' disabled={loading} className="mt-3 btn-color disabled:cursor-not-allowed rounded-md font-bold px-2 py-3 text-white transition-all text-lg duration-300 active:scale-95 disabled:bg-slate-500">
              {loading ? 
              <ClipLoader loading={loading} css={override} />
                :'Create account'}
            </button>
            {/* <button type='submit' disabled={!captchaVerified ? !captchaVerified : loading} className="mt-3 btn-color disabled:cursor-not-allowed rounded-md font-bold px-2 py-3 text-white transition-all text-lg duration-300 active:scale-95 disabled:bg-slate-500">
              {loading ? 
              <ClipLoader loading={loading} css={override} />
                :'Create account'}
            </button> */}
        </form>
        <p className='px-4 text-slate-600 '>Already have an account?<Link className='text-blue-700 font-medium' to='/login'>Log in</Link></p>
        <ToastContainer
        position="top-right"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme='dark'
        />
    </div>
 </div>
  )
}

export default Signup